import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import {
  NotificationExerciseBriefDto,
  PaginatedListOfExerciseAssetDto,
} from "@growth-machine-llc/stridist-api-client";
import ExerciseAssetsService from "../../../services/ExerciseAssetsService";
import { COACH_EXERCISE_LIBRARY_ASSETS_QUERY_KEY } from "../ExercisesTableScreen";
import { INVALIDATE_KEYS_ON_EXERCISE_LIST_UPDATE } from "./useArchiveRestoreLibraryExercise";
import { useQueryClient } from "@tanstack/react-query";
import { updateNotificationCacheOnExerciseApprovalActions } from "./useApprovePendingExerciseLibraryAsset";
import { useUpdateNotificationsCounter } from "../../../hooks/useUpdateCurrentUser";

// Hook for approving pending exercise assets directly without updating content
// If you need to update content, use useApprovePendingExerciseLibraryAsset
export const useDirectApprovePendingExerciseLibraryAsset = (
  notification: NotificationExerciseBriefDto,
) => {
  const queryClient = useQueryClient();
  const updateNotificationsCounter = useUpdateNotificationsCounter();

  return useOptimisticUpdateMutation({
    queryKey: [COACH_EXERCISE_LIBRARY_ASSETS_QUERY_KEY],
    mutationFn: ExerciseAssetsService.approvePendingExerciseAsset,
    optimisticUpdater: {
      updateFn: (oldData: PaginatedListOfExerciseAssetDto, variables) => {
        return {
          ...oldData,
          items: oldData.items.filter((item) => item.id !== variables.id),
        } as PaginatedListOfExerciseAssetDto;
      },
    },

    exactQueryKey: false,
    options: {
      onSuccess: () => {
        INVALIDATE_KEYS_ON_EXERCISE_LIST_UPDATE.forEach((queryKey) => {
          queryClient.invalidateQueries({
            queryKey: [queryKey],
            exact: false,
          });
        });

        updateNotificationCacheOnExerciseApprovalActions(
          queryClient,
          updateNotificationsCounter,
          notification,
        );
      },
    },
  });
};
